import { LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import { setLogoutAction } from 'common/commonRedux/auth/actions';
import { IConfirmModal } from 'common/components';
import { useIsDark } from 'common/hooks';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import MaleAvatar from './MaleAvatar.png';
function LogoutPopup({ closePopup, profileImage }: { closePopup: () => void; profileImage: string }) {
  const { t } = useTranslation();
  const isDark = useIsDark();
  const { profileData, originalTokenData } = useSelector((state: any) => state.auth, shallowEqual);
  const dispatch: any = useDispatch();
  const { emailaddress, orgName } = profileData?.tokenData || {};
  const handleLogout = () => {
    IConfirmModal({
      title: t('layout:logoutPopup.confirmTitle'),
      message: t('layout:logoutPopup.confirmMessage'),
      yesAlertFunc() {
        dispatch(setLogoutAction());
        closePopup();
      },
      noAlertFunc() {
        console.log("Cancelled")
      },
      buttonText: t('dashboard:logOutProfile:logout')
    });
  }
  return (
    <div
      className={`absolute right-0 top-[calc(100%+8px)] w-[260px] sm:w-[300px] rounded-xl border py-2 ${isDark ? 'border-[#2E3138] bg-[#0B172B]' : 'border-[#E2E8F0] bg-white'}`}
      style={{ boxShadow: isDark ? '0 10px 40px rgba(0, 0, 0, 0.6)' : '0 10px 40px rgba(0, 0, 0, 0.1)', zIndex: 999 }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* User Info */}
      <div className="flex items-center gap-3 px-4 py-3">
        <Avatar
          size={40}
          src={profileImage || MaleAvatar}
          className="flex-shrink-0"
        >
          {orgName?.charAt(0)}
        </Avatar>
        <div className="min-w-0 flex-1">
          <div className={`text-sm font-semibold truncate ${isDark ? 'text-white' : 'text-[#334155]'}`}>
            {originalTokenData ? originalTokenData?.orgName || 'Organization' : orgName || 'User'}
          </div>
          <div className={`text-xs truncate ${isDark ? 'text-[#94A3B8]' : 'text-[#94A3B8]'}`}>
            {originalTokenData ? originalTokenData?.emailaddress || '---' : emailaddress || '---'}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className={`mx-4 h-px ${isDark ? 'bg-[#2E3138]' : 'bg-[#F1F5F9]'}`} />

      {/* Menu Items */}
      <div className="py-1">
        <Link
          to="/settings?tab=account"
          onClick={closePopup}
          className={`flex items-center gap-3 px-4 py-2.5 transition-colors no-underline ${isDark ? 'text-[#CBD5E1] hover:bg-[#1E293B]' : 'text-[#475569] hover:bg-[#F8FAFC]'}`}
        >
          <SettingOutlined className="text-md text-[#94A3B8]" />
          <span className="text-sm font-medium">
            {t('dashboard:logOutProfile:accountSettings')}
          </span>
        </Link>

        <button
          onClick={() => handleLogout()}
          className={`flex items-center gap-3 px-4 py-2.5 w-full text-left text-[#EF4444] transition-colors border-0 bg-transparent cursor-pointer ${isDark ? 'hover:bg-[#EF44441A]' : 'hover:bg-[#FEF2F2]'}`}
        >
          <LogoutOutlined className="text-md" />
          <span className="text-sm font-medium">
            {t('dashboard:logOutProfile:logout')}
          </span>
        </button>
      </div>
    </div>
  );
}

export default LogoutPopup;
